import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../constants';
import { IsHelper } from './IsHelper';
import { UnwrapHelper } from './UnwrapHelper';
import { WrapHelper } from './WrapHelper';
export class UnwrapAccountHelper extends UnwrapHelper {
}
export class WrapAccountHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Account;
    }
}
export class IsAccountHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Account;
    }
}
export const hasAccount = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isAccount(context, node, tpe));
export const isOnlyAccount = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isAccount(context, node, tpe));
export const isAccount = (context, node, type) => context.builtins.isInterface(node, type, 'Account');

//# sourceMappingURL=account.js.map
